import { UserMinusIcon as PhosphorUserMinusIcon } from "@phosphor-icons/react/dist/ssr/UserMinus";

import { createAppIcon } from "@/components/createAppIcon";

export const PersonUnavailableIcon = /* @__PURE__ */ createAppIcon(PhosphorUserMinusIcon);
